/**
 * 브라우저 엔트리포인트 — Plan 05-05 Task 2.
 *
 * index.html 이 이 파일을 <script type="module"> 로 로드.
 * URL query 에서 streamerId/token/mode 를 파싱하고 VITE_* env base URL 을 합쳐
 * main.ts boot() 를 호출. 파라미터 누락은 즉시 fatal 렌더 후 반환.
 */
import { boot } from './main.js';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root not found');
}

const params = new URLSearchParams(window.location.search);
const streamerId = params.get('streamerId');
const token = params.get('token');
const apiBase = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000';
const wsBase = import.meta.env.VITE_WS_BASE_URL ?? 'ws://localhost:4000';

function renderFatal(message: string): void {
  const el = document.createElement('div');
  el.setAttribute('role', 'alert');
  el.style.position = 'fixed';
  el.style.left = '50%';
  el.style.top = '40%';
  el.style.transform = 'translate(-50%, -50%)';
  el.style.color = '#F27A7A';
  el.style.fontFamily = 'sans-serif';
  el.style.fontSize = '14px';
  el.style.padding = '12px 16px';
  el.style.background = 'rgba(0,0,0,0.6)';
  el.style.borderRadius = '6px';
  el.textContent = `위젯 부팅 실패: ${message}`;
  root!.append(el);
}

if (!streamerId || !token) {
  renderFatal('streamerId / token query 파라미터 필수');
} else {
  void boot({ root, streamerId, token, apiBase, wsBase });
}
